import base64 from 'react-native-base64';
import { firebase } from '../config/configureFirebase';
import AccessKey from './AccessKey';

// Route cache with 10-minute TTL to reduce API calls
const routeCache = new Map();
const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

const getCacheKey = (startLoc, destLoc, waypoints) => {
  return `${startLoc}_${destLoc}_${waypoints || 'null'}`;
};

const getCachedRoute = cacheKey => {
  const cached = routeCache.get(cacheKey);
  if (cached && Date.now() - cached.timestamp < CACHE_TTL) {
    return cached.data;
  }
  // Remove expired cache entry
  if (cached) {
    routeCache.delete(cacheKey);
  }
  return null;
};

const setCachedRoute = (cacheKey, data) => {
  routeCache.set(cacheKey, {
    data: data,
    timestamp: Date.now(),
  });

  // Keep cache size reasonable (max 100 entries)
  if (routeCache.size > 100) {
    const firstKey = routeCache.keys().next().value;
    routeCache.delete(firstKey);
  }
};

export const fetchPlacesAutocomplete = (searchKeyword, sessionToken) => {
  return new Promise((resolve, reject) => {
    const { config } = firebase;
    fetch(`https://${config.projectId}.web.app/googleapi`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Basic ' + base64.encode(config.projectId + ':' + AccessKey),
      },
      body: JSON.stringify({
        searchKeyword: searchKeyword,
        sessiontoken: sessionToken,
      }),
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json && json.searchResults) {
          resolve(json.searchResults);
        } else {
          reject(json.error);
        }
      })
      .catch(error => {
        console.log(error);
        reject('fetchPlacesAutocomplete Call Error');
      });
  });
};

export const fetchCoordsfromPlace = place_id => {
  return new Promise((resolve, reject) => {
    const { config } = firebase;
    fetch(`https://${config.projectId}.web.app/googleapi`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Basic ' + base64.encode(config.projectId + ':' + AccessKey),
      },
      body: JSON.stringify({
        place_id: place_id,
      }),
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json && json.coords) {
          resolve(json.coords);
        } else {
          reject(json.error);
        }
      })
      .catch(error => {
        console.log(error);
        reject('fetchCoordsfromPlace Call Error');
      });
  });
};

export const fetchAddressfromCoords = latlng => {
  return new Promise((resolve, reject) => {
    const { config } = firebase;
    fetch(`https://${config.projectId}.web.app/googleapi`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Basic ' + base64.encode(config.projectId + ':' + AccessKey),
      },
      body: JSON.stringify({
        latlng: latlng,
      }),
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json && json.address) {
          resolve(json.address);
        } else {
          reject(json.error);
        }
      })
      .catch(error => {
        console.log(error);
        reject('fetchAddressfromCoords Call Error');
      });
  });
};

export const getDistanceMatrix = (startLoc, destLoc) => {
  return new Promise((resolve, reject) => {
    const { config } = firebase;
    fetch(`https://${config.projectId}.web.app/googleapi`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Basic ' + base64.encode(config.projectId + ':' + AccessKey),
      },
      body: JSON.stringify({
        start: startLoc,
        dest: destLoc,
        calltype: 'matrix',
      }),
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.error) {
          console.log(json.error);
          reject(json.error);
        } else {
          resolve(json);
        }
      })
      .catch(error => {
        console.log(error);
        reject('getDistanceMatrix Call Error');
      });
  });
};

export const getDirectionsApi = (startLoc, destLoc, waypoints) => {
  return new Promise((resolve, reject) => {
    // Check cache first
    const cacheKey = getCacheKey(startLoc, destLoc, waypoints);
    const cachedResult = getCachedRoute(cacheKey);

    if (cachedResult) {
      console.log('Using cached route result for:', cacheKey);
      resolve(cachedResult);
      return;
    }

    const { config } = firebase;
    const body = {
      start: startLoc,
      dest: destLoc,
      calltype: 'direction',
    };
    if (waypoints) {
      body['waypoints'] = waypoints;
    }

    console.log('Making new API call for route:', cacheKey);
    fetch(`https://${config.projectId}.web.app/googleapi`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Basic ' + base64.encode(config.projectId + ':' + AccessKey),
      },
      body: JSON.stringify(body),
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.hasOwnProperty('distance_in_km')) {
          // Cache the successful result
          setCachedRoute(cacheKey, json);
          resolve(json);
        } else {
          console.log(json.error);
          reject(json.error);
        }
      })
      .catch(error => {
        console.log(error);
        reject('getDirectionsApi Call Error');
      });
  });
};
